import React from 'react';
import { PropTypes } from 'prop-types';

import ModalWrapper from 'components/Modals/ModalWrapper';

const DeleteBatchModal = ({
  isShown,
  isDeletingBatch,
  onConfirmDelete,
  onCancel,
  deleteBatchError
}) => (
  <ModalWrapper
    headerClose={ false }
    isOpen={ isShown }
    title="Permanently Delete Batch"
    btnConfirmTitle="Delete"
    btnConfirmClass={ `btn-danger ${ isDeletingBatch ? 'loading' : '' }` }
    btnCancelTitle="Cancel"
    onConfirm={ onConfirmDelete }
    onCancel={ onCancel }
  >
    <p>
      Are you sure you want to permanently delete this batch?
    </p>
    {
      deleteBatchError
      && <div className="toast toast-error">
        { deleteBatchError }
      </div>
    }
  </ModalWrapper>
);

DeleteBatchModal.propTypes = {
  isShown: PropTypes.bool,
  isDeletingBatch: PropTypes.bool,
  onConfirmDelete: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  deleteBatchError: PropTypes.string
};

DeleteBatchModal.defaultProps = {
  isShown: false,
  isDeletingBatch: false,
  deleteBatchError: null
};

export default DeleteBatchModal;
